module.exports = __webpack_public_path__ + "static/media/icon_minatocdae51984cea18085d26dc432844b84d.webp";